import {
  BASE_PROJECT_DEVELOPMENT_CONFIG,
  ProjectDevelopmentStructure,
  PRELIMINARY_DESIGN,
  ProjectTypeStructure,
  WORKING_DOCUMENTATION,
} from '../../../components';
import {
  ENGINEERING_SYSTEMS_CDN_PATH,
  ENGINEERING_SYSTEMS_STORAGE_PATH,
} from '../../../engineering-systems-constants';
import {
  VENTILATION_PRELIMINARY_DESIGN_ID,
  VENTILATION_WORKING_DOCUMENTATION_ID,
} from '../../ventilation-systems-constants';

export const VENTILATION_PROJECT_TYPE_LIST: ProjectTypeStructure[] = [
  {
    ...PRELIMINARY_DESIGN,
    id: VENTILATION_PRELIMINARY_DESIGN_ID,
    consultationSignup: {
      href: `${ENGINEERING_SYSTEMS_STORAGE_PATH}sistemy-ventilyacii-i-kondicionirovaniya-primer-eskiznogo-proekta.pdf`,
      src: `${ENGINEERING_SYSTEMS_CDN_PATH}/features/1.svg/1.svg`,
      label: 'Скачать пример',
    },
  },
  {
    ...WORKING_DOCUMENTATION,
    id: VENTILATION_WORKING_DOCUMENTATION_ID,
    consultationSignup: {
      href: `${ENGINEERING_SYSTEMS_STORAGE_PATH}sistemy-ventilyacii-i-kondicionirovaniya-primer-rabochey-dokumentacii.pdf`,
      src: `${ENGINEERING_SYSTEMS_CDN_PATH}/heating/2.svg/2.svg`,
      label: 'Скачать пример',
    },
    priceUnits: '/м²',
  },
];

export const VENTILATION_DEVELOPMENT: ProjectDevelopmentStructure = {
  ...BASE_PROJECT_DEVELOPMENT_CONFIG,
  id: VENTILATION_WORKING_DOCUMENTATION_ID,
  compositionList: WORKING_DOCUMENTATION.compositionList,
  exampleHref: `${ENGINEERING_SYSTEMS_STORAGE_PATH}sistemy-ventilyacii-i-kondicionirovaniya-primer-rabochey-dokumentacii.pdf`,
  priceUnits: '/м²',
  schedule: WORKING_DOCUMENTATION.schedule,
};
